let lastLoginEffectUser: string | null = null;

export const shouldRunLoginEffect = (document: string): boolean => {
  if (!document || lastLoginEffectUser === document) return false;
  lastLoginEffectUser = document;
  return true;
};

export const resetLoginEffectGuard = () => {
  lastLoginEffectUser = null;
};
